module.exports = __webpack_public_path__ + "static/media/sistema-emissor.c5f5caa1.jpg";